import React from 'react'
import Link from 'gatsby-link'
import Cookies from 'js-cookie'
import styled from 'styled-components'
const Div = styled.div`
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  z-index: 1200;
  display: ${props => (props.shown === true ? 'block' : 'none')};
  .cookie-notification {
    display: inline-flex;
    align-items: center;
    border-radius: 0.25rem !important;
    margin: 0 auto;
    padding: 10px;
    background-color: #f8f9fa !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
`

export default class CookieNotification extends React.Component {
  constructor(props) {
    super(props)
    this.accept = this.accept.bind(this)

    this.state = {
      isShown: false,
    }
  }
  componentDidMount() {
    const cookieInformation = Cookies.get('cookie-information')
    const container = document.getElementById('cookie-notification-container')
    const button = document.getElementById('cookie-notification-btn')
    if (cookieInformation === undefined) {
      this.show()
    }
  }
  hide() {
    this.setState({
      isShown: false,
    })
  }
  show() {
    this.setState({
      isShown: true,
    })
  }
  accept() {
    Cookies.set('cookie-information', '1.0.0', { expires: 1095 })
    this.hide()
  }
  render() {
    return (
      <Div
        shown={this.state.isShown}
        id="cookie-notification-container"
        rel="cookie-notification"
      >
        <div className="cookie-notification border">
          <span className="cookie-notification-copy">
            By using this website you agree to our{' '}
            <a className="common-Link" href="/cookies-policy">
              cookie policy
            </a>
          </span>
          <button
            id="cookie-notification-btn"
            type="button"
            className="ml-3 btn btn-primary"
            onClick={this.accept}
          >
            Accept
          </button>
        </div>
      </Div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CookieNotification/CookieNotification.js